<div
  role="button"
  dropzone
  (selectedFiles)="onFileSelected($event)"
  (click)="fileInput.click()"
  class="drop-zone d-flex flex-column align-items-center s-p-5 border bg-primary-soft-background border-clr-primary-brand-color"
  [class.drop-zone--invalid]="formControlRef().touched && formControlRef().invalid"
>
  <div
    class="bg-primary-brand-color c-white border rounded-circle s-w-12 s-h-12 d-flex align-items-center justify-content-center s-grow-1"
  >
    <mat-icon> attach_file </mat-icon>
  </div>
  <strong class="c-primary-brand-color s-mt-4"> {{ 'COMMON.ADD_FILE' | translate }}... </strong>
</div>

<input
  #fileInput
  id="file-input-playwright"
  type="file"
  [multiple]="multiple()"
  [accept]="accept().join(',')"
  style="position: absolute; width: 1px; height: 1px; opacity: 0"
  (change)="onFileSelected($event)"
/>

@if (formControlRef().touched && formControlRef().invalid) {
  <p class="file-uploader-error">Este documento é obrigatório.</p>
}

<div class="s-mt-3">
  <div
    *ngFor="let existingFile of visibleExistingFiles"
    class="d-flex align-items-center bg-primary-soft-background s-p-4 s-mb-2"
  >
    <div
      class="col-md-2 bg-primary-brand-color c-white border rounded-circle s-w-12 s-h-12 d-flex align-items-center justify-content-center"
    >
      <mat-icon> attach_file </mat-icon>
    </div>
    <div class="s-ms-4 col-md-9">
      <strong class="c-primary-brand-color">{{ existingFile.name }}</strong>
      <small class="d-block" *ngIf="existingFile.size">
        {{ existingFile.size | fileSize }}
      </small>
      <small class="d-block c-status-success" *ngIf="!existingFile.size">
        Arquivo salvo
      </small>
    </div>
    <div class="col-md-1 d-flex gap-1">
      <button
        *ngIf="existingFile.fileId"
        class="border-0 bg-transparent"
        (click)="fileDownload.emit(existingFile)"
      >
        <mat-icon class="c-primary-brand-color"> download </mat-icon>
      </button>
      <button class="border-0 bg-transparent" (click)="removeExistingItem(existingFile)">
        <mat-icon class="c-status-error"> delete </mat-icon>
      </button>
    </div>
  </div>

  <app-file-uploader-item
    *ngFor="let file of localFiles"
    [file]="file"
    (remove)="removeItem($event)"
  >
  </app-file-uploader-item>
</div>
